const SelectTheme = (theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary: "#090a3a",
  },
});

export default SelectTheme;
